// extracted by mini-css-extract-plugin
export default {"popup":"SZ5BWOjxMxZMzkEjNkjw","titleBlock":"DboUvGUMf8W9YwsHSABw","title":"WnkwG_Org0k9XyGwZFi4","close":"c5BIdMTRVGg2E2f7oGVh"};